
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-profiles",
      function () {
        return require("private-next-pages/social-profiles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-profiles"])
      });
    }
  